


export var config = {

	utcoffset: "+0100",
	testLocations: ['localhost'],
	startTime: Date.now(),
	intervalUpdateTimeLogicS: 10,
	intervalReloadContentsMin: 30,
	limitedCountryCodes: ["CN","IR","KP","CU","ID","SY","SD"],
	faRulerSymbol: 'fa fa-star',


	// passwordHash: "37f99c98160b991b9a81925f8df132ca",
	// passwordCookieExpirationDays: 30,

	// currentScheduleItemLinksTo: "#about",

	gotoStartButtonTime: "29.9.2020, 15:49:50",
}
